import { PlannerRootView } from "./views";

export const plannerRoutes: Spintr.ISpintrUiRoute[] = [{
    component: PlannerRootView,
    path: "/timeline",
}];
